import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=63e7c380&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=63e7c380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7c380",
  null
  
)

export default component.exports